import {
  chooseImage,
  type FabricPhotoChooseImageFileApi,
} from './choose-image.js';
import {
  closePreviewImage,
  type FabricClosePhotoPreviewImageFileApi,
  type FabricPhotoPreviewImageFileApi,
  previewImage,
} from './preview-image.js';
import {
  type FabricPhotoSaveImageToPhotosAlbumApi,
  saveImageToPhotosAlbum,
} from './save-image-to-photos-album.js';

export type FabricPhotoApi = {
  /**
   * 从本地相册选择图片或使用相机拍照。
   */
  chooseImage: FabricPhotoChooseImageFileApi;
  /**
   * 关闭当前图片预览器
   */
  closePreviewImage: FabricClosePhotoPreviewImageFileApi;
  /**
   * 在新页面中全屏预览图片。
   */
  previewImage: FabricPhotoPreviewImageFileApi;

  /**
   * 保存图片到本地相册; 比如保存二维码.
   */
  saveImageToPhotosAlbum: FabricPhotoSaveImageToPhotosAlbumApi;
};

export const fabricPhoto: FabricPhotoApi = {
  chooseImage,
  closePreviewImage,
  previewImage,
  saveImageToPhotosAlbum,
};
